import { getIsSafeUrl } from '@frontend/utils';

import { formatVisitableUrl } from '../formatters';

export const validateUrlWithOptionalProtocol = (value: string): boolean =>
  getIsSafeUrl(formatVisitableUrl(value));
